import { FormDropdown } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'

import { I18n } from 'lib/i18n'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  arrayMove,
  arrayPush,
  arrayRemove,
  arraySwap,
  change,
  Field,
  getFormValues,
} from 'redux-form'
import { confirmationModal } from 'redux/navigation'
import { createProperty } from 'redux/product'
import {
  Button,
  Divider,
  Grid,
  Header,
  Icon,
  Segment,
  Table,
} from 'semantic-ui-react'
import {
  ExistingProperty,
  NewProperty,
  NewText,
} from './ProductPropertyNewRows'
import ProductPropertyRow from './ProductPropertyRow'

const mapStateToProps = (state, ownProps) => {
  const formValues = getFormValues(ownProps.form)(state)
  const formProperties = formValues ? formValues.properties : []
  const selectablePropertyIds = formValues ? formValues.selectablePropertyIds : []
  return {
    formProperties,
    selectablePropertyIds,
    formNewRow: formValues.new_row,
    editingProperty: formValues.editingProperty,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      arraySwap,
      arrayRemove,
      change,
      arrayMove,
      arrayPush,
      createProperty,
      confirmationModal,
    },
    dispatch
  )
}

class ProductPropertyList extends React.Component {
  static propTypes = {
    form: PropTypes.string.isRequired,
    properties: PropTypes.array.isRequired,
  }
  state = {
    dragMarker: {},
  }

  getPropertyOptions() {
    return [
      {
        key: 1,
        text: I18n.t('admin.productProperties.new_property'),
        value: 'new',
      },
      {
        key: 2,
        text: I18n.t('admin.productProperties.existing_property'),
        value: 'add',
      },
      {
        key: 3,
        text: I18n.t('admin.productProperties.new_text'),
        value: 'text',
      },
    ]
  }

  findProperty(dragId) {
    const { formProperties } = this.props
    const item = formProperties.find((property) => property.dragId === dragId)
    return {
      item,
      index: formProperties.indexOf(item),
    }
  }

  swapProperty(dragIndex, hoverIndex) {
    const { arraySwap, form } = this.props
    arraySwap(form, 'properties', dragIndex, hoverIndex)
  }

  moveProperty(dragIndex, hoverIndex) {
    const { arrayMove, form } = this.props
    arrayMove(form, 'properties', dragIndex, hoverIndex)
  }

  getProductPropertyRows(sortable) {
    const { dragMarker = {} } = this.state
    const {
      properties: allProperties,
      formProperties,
      editingProperty,
      arrayRemove,
      change,
      form,
      confirmationModal,
    } = this.props
    if (!formProperties || allProperties.length === 0) return []
    return formProperties
      .map((productProperty, index) => {
        if (!sortable && productProperty.property_id === 1) return undefined
        if (productProperty.user_selectable) return undefined
        if (productProperty.property_id !== 1) {
          const realProperty =
            allProperties.find(
              (realProperty) => productProperty.property_id === realProperty.id
            ) || {}
          if (realProperty.sortable !== sortable) return undefined
          //        if (productProperty.property_id === 1 && !sortable) return undefined;
          const propertyOptionsDe = realProperty.property_values
            ? realProperty.property_values.map((value) => ({
                text:
                  (value.value_de || '').substring(0, 80) +
                  ((value.value_de || '').length > 80 ? '...' : ''),
                value: value.id,
              }))
            : []
          const propertyOptionsFr = realProperty.property_values
            ? realProperty.property_values.map((value) => ({
                text:
                  (value.value_fr || '').substring(0, 80) +
                  ((value.value_fr || '').length > 80 ? '...' : ''),
                value: value.id,
              }))
            : []
          const propertyValue = realProperty.property_values
            ? realProperty.property_values.find(
                (prop) => prop.id === productProperty.property_value_id
              ) || {}
            : {}
          propertyOptionsDe.unshift({ text: '-', value: -1 })
          propertyOptionsFr.unshift({ text: '-', value: -1 })
          return (
            <ProductPropertyRow
              {...{
                key: index,
                index: index,
                form: form,
                sortable:
                  realProperty.sortable || productProperty.property_id === 1,
                propertyValue: propertyValue,
                editing: editingProperty === index,
                editRow: () => change(form, 'editingProperty', index),
                clearRow: () => change(form, 'editingProperty', -1),
                as: productProperty.category ? 'category' : 'default',
                name: `properties[${index}][property_value_id]`,
                propNameDe: realProperty.name_de,
                optionsDe: propertyOptionsDe,
                propNameFr: realProperty.name_fr,
                optionsFr: propertyOptionsFr,
                propertyId: productProperty.property_id,
                deleteRow: () => {
                  confirmationModal({
                    icon: config.icons.delete,
                    negative: true,
                    title: I18n.t('admin.product.deleteProperty.title'),
                    text: I18n.t('admin.product.deleteProperty.text'),
                    button: I18n.t('admin.product.deleteProperty.button'),
                    confirm: () => {
                      arrayRemove(form, 'properties', index)
                      change(form, 'editingProperty', -1)
                    },
                  })
                },
                dragId: productProperty.dragId,
                beginDrag: () => change(form, 'editingProperty', -1),
                findItem: (dragId) => this.findProperty(dragId),
                moveItem: (oldIndex, newIndex) =>
                  this.moveProperty(oldIndex, newIndex),
                setDragMarker: (dragMarker) => this.setState({ dragMarker }),
                dragMarker: dragMarker.index === index && dragMarker,
              }}
            />
          )
        } else {
          if (productProperty.property_id !== 1) return false
          return (
            <ProductPropertyRow
              {...{
                key: index,
                index: index,
                form: form,
                sortable: editingProperty === -1,
                productProperty: productProperty,
                editing: editingProperty === index,
                editRow: () => change(form, 'editingProperty', index),
                clearRow: () => change(form, 'editingProperty', -1),
                as: 'text',
                nameDe: `properties[${index}][value_de]`,
                nameFr: `properties[${index}][value_fr]`,
                deleteRow: () => {
                  confirmationModal({
                    icon: config.icons.delete,
                    negative: true,
                    title: I18n.t('admin.product.deleteProperty.title'),
                    text: I18n.t('admin.product.deleteProperty.text'),
                    button: I18n.t('admin.product.deleteProperty.button'),
                    confirm: () => {
                      arrayRemove(form, 'properties', index)
                      change(form, 'editingProperty', -1)
                    },
                  })
                },
                dragId: productProperty.dragId,
                beginDrag: () => change(form, 'editingProperty', undefined),
                findItem: (dragId) => this.findProperty(dragId),
                moveItem: (dragIndex, hoverIndex) =>
                  this.swapProperty(dragIndex, hoverIndex),
                setDragMarker: (dragMarker) => this.setState({ dragMarker }),
                dragMarker: dragMarker.index === index && dragMarker,
              }}
            />
          )
        }
      })
      .filter((propertyRow) => !!propertyRow)
  }

  getFamilyPropertyRows() {
    const { properties: allProperties, familyProperties = [] } = this.props
    return familyProperties.map((productProperty, index) => {
      const realProperty =
        allProperties.find(
          (realProperty) => productProperty.property_id === realProperty.id
        ) || {}
      const propertyOptionsDe = realProperty.property_values
        ? realProperty.property_values.map((value) => ({
            text: value.value_de,
            value: value.id,
          }))
        : []
      const propertyOptionsFr = realProperty.property_values
        ? realProperty.property_values.map((value) => ({
            text: value.value_fr,
            value: value.id,
          }))
        : []
      const propertyValue = realProperty.property_values
        ? realProperty.property_values.find(
            (prop) => prop.id === productProperty.property_value_id
          ) || {}
        : {}
      return (
        <ProductPropertyRow
          {...{
            key: index,
            index: index,
            sortable: false,
            propertyValue: propertyValue,
            editing: false,
            readOnly: true,
            as: 'family',
            propNameDe: realProperty.name_de,
            optionsDe: propertyOptionsDe,
            propNameFr: realProperty.name_fr,
            optionsFr: propertyOptionsFr,
            propertyId: productProperty.property_id,
          }}
        />
      )
    })
  }

  getSelectablePropertyRows() {
    const {
      properties: allProperties,
      selectablePropertyIds = [],
      form,
      arrayRemove,
      confirmationModal,
    } = this.props
    return selectablePropertyIds.map((id, index) => {
      const property = allProperties.find((p) => p.id === id) || {}
      return (
        <Table.Row>
          <Table.Cell collapsing />
          <Table.Cell children={property.name_de} />
          <Table.Cell
            className="secondary"
            width={5}
            children={property.name_fr}
          />
          <Table.Cell textAlign="right" width={2}>
            <Icon
              link
              size="large"
              {...config.icons.delete}
              onClick={() => {
                confirmationModal({
                  icon: config.icons.delete,
                  negative: true,
                  title: I18n.t('admin.product.deleteProperty.title'),
                  text: I18n.t('admin.product.deleteProperty.text'),
                  button: I18n.t('admin.product.deleteProperty.button'),
                  confirm: () => {
                    arrayRemove(form, 'selectableProperties', index)
                  },
                })
              }}
            />
          </Table.Cell>
        </Table.Row>
      )
    })
  }

  render() {
    const {
      form,
      formNewRow,
      familyProperties = [],
      selectablePropertyIds = [],
      properties = [],
      change,
      createProperty,
      arrayPush,
    } = this.props
    return (
      <Segment basic attached className="payload">
        <Grid stackable verticalAlign="middle">
          <Grid.Row>
            <Grid.Column width={3}>
              <Field
                component={FormDropdown}
                options={this.getPropertyOptions()}
                name="new_row"
                trigger={
                  <Button
                    primary
                    content={I18n.t('admin.productProperties.new')}
                    icon="plus"
                    labelPosition="right"
                  />
                }
                icon={false}
                pointing="left"
              />
            </Grid.Column>
            <Grid.Column width={9}>
              <p
                className="unobtrusive"
                children={I18n.t('admin.productProperties.hint_dropdowns')}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Table basic="very" size="small" compact className="spaced new">
                <Table.Body>
                  <NewText
                    visible={formNewRow === 'text'}
                    parentForm={form}
                    hide={() => {
                      change(form, 'new_row', 'nothing')
                    }}
                    addText={(newTextDe, newTextFr) =>
                      arrayPush(form, 'properties', {
                        property_id: 1,
                        value_de: newTextDe,
                        value_fr: newTextFr,
                        dragId: new Date().getTime(),
                      })
                    }
                  />
                  <NewProperty
                    visible={formNewRow === 'new'}
                    hide={() => {
                      change(form, 'new_row', 'nothing')
                    }}
                    createProperty={(newPropertyDe, newPropertyFr) =>
                      createProperty(form, newPropertyDe, newPropertyFr)
                    }
                  />
                  <ExistingProperty
                    visible={formNewRow === 'add'}
                    parentForm={form}
                    hide={() => {
                      change(form, 'new_row', 'nothing')
                    }}
                    newProperty={(propertyId) => {
                      const property =
                        properties.find((p) => p.id === propertyId) || {}
                      if (property.user_selectable)
                        arrayPush(form, 'selectablePropertyIds', propertyId)
                      else
                        arrayPush(form, 'properties', {
                          property_id: propertyId,
                          property_value_id: -1,
                          dragId: new Date().getTime(),
                        })
                    }}
                  />
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {familyProperties.length > 0 && (
          <div>
            <Header
              as="h3"
              content={I18n.t('admin.productProperties.family_properties')}
            />
            <Table
              basic="very"
              size="small"
              compact
              className="spaced ProductProperties">
              <Table.Body children={this.getFamilyPropertyRows()} />
            </Table>
          </div>
        )}
        <Divider className="compact" />
        <Header
          as="h3"
          content={I18n.t('admin.productProperties.fixed_properties')}
        />
        <Table
          basic="very"
          size="small"
          compact
          className="spaced ProductProperties">
          <Table.Body children={this.getProductPropertyRows(false)} />
        </Table>
        <Header
          as="h3"
          content={I18n.t('admin.productProperties.sortable_properties')}
        />
        <Table
          basic="very"
          size="small"
          compact
          className="spaced ProductProperties sortable">
          <Table.Body children={this.getProductPropertyRows(true)} />
        </Table>
        {selectablePropertyIds.length > 0 && (
          <div>
            <Header
              as="h3"
              content={I18n.t('admin.productProperties.selectable_properties')}
            />
            <Table
              basic="very"
              size="small"
              compact
              className="spaced ProductProperties">
              <Table.Body children={this.getSelectablePropertyRows()} />
            </Table>
          </div>
        )}
      </Segment>
    )
  }
}

ProductPropertyList = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductPropertyList)
export default ProductPropertyList



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductPropertyList.jsx